import OpenedImagePerspectivas from "./OpenedImagePerspectivas";

export default OpenedImagePerspectivas;
